import { DataBean } from "../../DataBean";


export class PharmaRecordState extends DataBean {

    public async getPharmaRecordStateCatalog(regexStr: any, page: any, recordsPerPage: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getPharmaRecordStateCatalog_String_Number_Number", [regexStr, page, recordsPerPage]);
    }

}